var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"site-name"},[_vm._v(_vm._s(_vm.$store.state.site.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }